import React from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/branch_circuts.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';

/* istanbul ignore next -- @preserve */
export function DevicePowerUpInstructions() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const backURL = useParamBackUrl('../device-register?direction=back');

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')} backURL={backURL}>
      <Center flexDirection="column" px={3} textAlign="center">
        <Image data-testid="ev-charger-image" src={chargerImg} alt="Charging Station" my={4} />

        <Heading mt={2}>{t('Set Up Hardware.activate wifi ap')}</Heading>
        <Text data-testid="ev-setup-text" mt={1}>
          {t('Set Up Hardware.to activate ev charger')}
        </Text>
        <Text mt={4}>
          {t('Set Up Hardware.needed to connect device to wifi', { device: t('Set Up Hardware.charging station') })}
        </Text>

        <ArcButton
          data-testid="ev-charger-continue"
          onClick={() => navigate('../device-scan')}
          mt={8}
          w={'80%'}
          arcColor="#3DCD57"
        >
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
